/**
 * Class for handling uifeatures REST request
 * @copyright 2021-2026 Soter Technologies, LLC. All rights reserved.
 * @file uiFeatures.js
 * @author Bryan Lai, Kyle Watkins, Paul Scala
 */

class UiFeatures {
    /**
     * Initialize class
     * @param {object} axios Axios instance
     * @param {object} session User session handler
     */
    constructor(axios, session) {
        this.axios = axios
        this.session = session
    }

    /**
     * Lookup All Ui Features
     * @param {object} query Query to filter
     * @param {number} query.page Page number of data
     * @param {string} query.order Order of data
     * @param {string} query.search String to search 
     * @param {string} query.sortBy Field to sort by
     * @param {boolean} query.countOnly Only get the count of groups back
     * @param {boolean} query.siteSpecific If true, only get siteSpecific uiFeatures (False is only non-siteSpecific, null is for all)
     * @returns {ResponseObject} Api response object
     */
    async lookupAllUiFeatures({page = 0, order = 'ASC', search = "", sortBy = "", countOnly = false, siteSpecific = null} = {}) {
        /**
         * Pseudo Code
         *  Initialize search filters
         *  Get query to filter by
         *  Set request config
         *  Get uiFeatures
         */

        // Initialize search filters
        let searchFilters = {
            order,
            siteSpecific,
            ...(search === "") ? {} : {search},
            ...(sortBy === "") ? {} : {sortBy},
        }

        // Get query to filter by
        let query = this.session.getQuery({page, searchFilters, countOnly})

        // Set request config
        let config = {
            method: 'get',
            url: `/api/uifeatures/all/lookup${"?" + query}`,
        }

        // Get groups
        let res = await this.axios(config)
    
        return ({
            status: res.status, 
            statusText: res.statusText,
            isSuccess: (res.status >= 200 && res.status < 300),
            data: res.data
        })
    }

}

export default UiFeatures